import { render } from "./CancelSearchIcon.vue?vue&type=template&id=bd2102ac"
const script = {}
script.render = render

export default script